import React,{useState,useEffect,useRef} from 'react';
import PDFViewer from '../../SharedModule/PDF/PDFViewer';
import APIDevPDF from './IOX API Documentation_ProductDev.pdf';
import APIQAPDF from './IOX API Documentation_ProductQA.pdf';
import APIMOPDF from './IOX API Documentation_ProductMO.pdf';
import MemEnPDF from './Member educational material V0.1.pdf';

const Help=(props)=>{
   const [moduleName,setModulename]=useState("");
   const [PDFData,setPDFData]=useState(null);
   const [docTitle,setDocTitle]=useState("");
   const viewerRef = useRef(null);
   useEffect(()=>{
      const queryDocName = typeof window !== 'undefined' ? new URLSearchParams(window.location.search).get('docName') : null;
      const storedDocName = localStorage.getItem("IoxDocName");
      setModulename(queryDocName || storedDocName || "");
   },[]);

   useEffect(()=>{
      switch (moduleName) {
         case "API":
            setDocTitle("API Documentation");
            if(process.env.REACT_APP_ENV == "LOCAL" || process.env.REACT_APP_ENV == "DEV" ){
               setPDFData(APIDevPDF);
            }else if(process.env.REACT_APP_ENV == "QA"){
               setPDFData(APIQAPDF);
            }else if(process.env.REACT_APP_ENV == "UAT"){
               setPDFData(APIMOPDF);
            }
            else if(process.env.REACT_APP_ENV == "PROD"){
               setPDFData(APIMOPDF);
            }
            break;
         case "Education_Materials":
            setDocTitle("Review Educational Materials");
            setPDFData(MemEnPDF);
            break;
         default:
            break;
      }
   },[moduleName]);

   useEffect(() => {
      if (!viewerRef.current) return;

      const addAccessibleNames = () => {
         const links = viewerRef.current.querySelectorAll("a.internalLink, a.externalLink");

         links.forEach((link, index) => {
            const text = link.textContent && link.textContent.trim();
            const ariaLabel = link.getAttribute("aria-label");
            const title = link.getAttribute("title");

            if (!text && !ariaLabel) {
               link.setAttribute("aria-label", `PDF link ${index + 1}`);
            }

            if (!title) {
               link.setAttribute("title", `PDF link ${index + 1}`);
            }
         });
      };

      addAccessibleNames();

      const observer = new MutationObserver(() => {
         addAccessibleNames();
      });

      observer.observe(viewerRef.current, {
         childList: true,
         subtree: true
      });

      return () => observer.disconnect();
   }, [PDFData]);

   return (
   <div className="content-wrapper">
      <div className="page-header mob-main-head">
         <h2 className="page-heading float-left">{docTitle || "API Documentation"}</h2>
         <div className="clearfix"></div>
      </div>
      <div className="tab-body-bordered pt-3">
         <div className="block-elm container-space" ref={viewerRef}>
            <PDFViewer PDF={PDFData}/>
         </div>
      </div>
   </div>
   )
}

export default Help;